import React from 'react';
import { Box, Typography, Card, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function PrizesSection() {
	return (
		<Card sx={{
			maxWidth: 600,
			mx: 'auto',
			my: 6,
			p: { xs: 3, sm: 4 },
			borderRadius: 4,
			boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
			background: '#fff',
		}}>
			<Box sx={{ textAlign: 'center', mb: 3 }}>
				<span role="img" aria-label="trophy" style={{ fontSize: 40, color: '#FFD700', display: 'block', margin: '0 auto 8px auto' }}>🏆</span>
				<Typography variant="h4" component="h2" sx={{ fontWeight: 'bold', color: '#222', textAlign: 'center', mb: 1 }}>
					Prizes & Awards
				</Typography>
				<Typography variant="h6" component="h6" color="text.secondary" sx={{ mb: 2, fontSize: { xs: '1.15rem', sm: '1.25rem' }, fontWeight: 500, textAlign: 'center' }}>
					Over $7,500 in prizes plus exclusive benefits
				</Typography>
			</Box>
			<List>
				{[
					'Direct mentorship from industry leaders',
					'Funding opportunities',
					'Accelerator program access',
					'Access to investor networks',
					'Featured on the LIH platform',
					'Access to startup resources and tools',
				].map((text, idx) => (
					<ListItem key={idx} sx={{ py: 1 }}>
						<ListItemIcon>
							<CheckCircleIcon sx={{ color: '#219653', fontSize: 28 }} />
						</ListItemIcon>
						<ListItemText primary={text} primaryTypographyProps={{ fontSize: '1.08rem', color: '#222' }} />
					</ListItem>
				))}
			</List>
		</Card>
	);
}
